import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openWithMessage: {
		id: 'development-summary-development-field.summary.open-in-vscode.open-with-message',
		defaultMessage: 'Open with VS Code',
		description:
			"The cta users click to open the jira issue in an external SCM tool. 'VS Code' is a trademark and should not be translated.",
	},
});
